import { render, staticRenderFns } from "./managedInstructionAssignmentOverdueSendReminder.vue?vue&type=template&id=5b108d82"
import script from "./managedInstructionAssignmentOverdueSendReminder.vue?vue&type=script&lang=js"
export * from "./managedInstructionAssignmentOverdueSendReminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports